module.exports = __webpack_public_path__ + "img/90sn_pack.4bb2f630.png";